<template>
    <div>
        <nav-bar>
            <template v-slot:default>用户登录</template>    
        </nav-bar>
        <div style="margin-top: 50px">
            <div style="text-align:center;padding-top:50px;">
                <van-image
                    width="10rem"
                    height="10rem"
                    fit="contain"
                    src="https://img01.yzcdn.cn/vant/cat.jpeg"
                />
            </div>
            <van-form @submit="onSubmit">
                <van-field
                    v-model="email"
                    name="用户名"
                    label="用户名"
                    placeholder="用户名"
                    :rules="[{ required: true, message: '请填写用户名' }]"
                />
                <van-field
                    v-model="password"
                    type="password"
                    name="密码"
                    label="密码"
                    placeholder="密码"
                    :rules="[{ required: true, message: '请填写密码' }]"
                />
                <div style="margin: 16px;">
                    <div class="link-login" @click="$router.push({path:'/register'})">
                        没有账号,立即注册
                    </div>
                    <van-button round block type="info" color="#44b883" native-type="submit">提交</van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>
<script>
import NavBar from 'components/common/navbar/NavBar'
// 消息通知
import { Notify } from 'vant';
import {ref,reactive,toRefs} from 'vue'
import {login} from 'network/user'
import {useRouter} from 'vue-router'
// 状态管理
import {useStore} from 'vuex'
// 轻提示
import { Toast } from 'vant';
export default {
    name:'login',
    components: {
        NavBar
    },
    setup(){
        const store = useStore();
        const router = useRouter();
        const userinfo = reactive({
            email:'',
            password:'',
        })
        const onSubmit = ()=>{
            login(userinfo).then(res=>{
                // 将token保存在本地 window.localStorage  setItem(key,value) getItem(key)
                window.localStorage.setItem('token',res.access_token);
                // 在 vuex isLogin
                store.commit('setIsLogin',true);

                
                Toast.success('登录成功');
                userinfo.email = '';
                userinfo.password = '';
                setTimeout(()=>{
                    router.go(-1);
                },500)
            })
        }
        return{
            ...toRefs(userinfo),
            onSubmit
        }
    }
}
</script>
<style scoped>
    .link-login{
        font-size: 14px;
        margin-bottom: 20px;
        color: #42b983;
        display: inline-block;
        float: left;
    }
</style>
